import Vue from 'vue'
import store from '@/store'

Vue.prototype.$snackbar = (text, type, timeout = 2000) => {
  store.dispatch('app/showSnackbar', { text, type, timeout })
}
Vue.prototype.$loader = loader => {
  store.dispatch('app/setLoader', loader)
}
